import React from "react";
import { Card } from "../../../common";
import { ReactComponent as Magnifier } from "../../../../assets/icons/Magnifier.svg";

export const FollowedCompany = () => {
  return (
    
      <div>
        <h3 className="text-left text-f24 text-primary font-bold">
        Followed businesses
        </h3>
        <p className="text-left text-f16 text-secondarytwo mb-4">
        View updates and changes from all the businesses you are following here.
        </p>
      </div>
  );
};
